import gs1Instance from '../api-index'

const { post, get, patch, put, delete: deleteRequest } = gs1Instance

const getAllUsers = async params => {
  const response = await get(`/gs1/standard/users`, params)
  return response.data
}

const createUser = async payload => {
  const response = await post(`/gs1/standard/users`, payload)
  return response.data
}

const updateUser = async (id, payload) => {
  const response = await put(`/gs1/standard/users/${id}`, payload)
  return response.data
}

const deleteUser = async id => {
  const response = await deleteRequest(`/gs1/standard/users/${id}`)
  return response.data
}

export { getAllUsers, createUser, updateUser, deleteUser }